import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74118690&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=74118690&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74118690",
  null
  
)

export default component.exports